<template>
  <svg :width="width" :height="height" xmlns="http://www.w3.org/2000/svg"><g stroke-width="1.25" :class="searchClass" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor" viewBox="0 0 19 19"><path d="M8.556 16.111A7.556 7.556 0 1 0 8.556 1a7.556 7.556 0 0 0 0 15.111ZM18 18l-4.108-4.108L18 18Z" />
  </g>
  </svg>
</template>

<script>
export default {
  name: 'Search',
  props: {
    color: {
      type: String,
      default: 'dark',
    },
    width: {
      type: [String, Number],
      default: '19px',
    },
    height: {
      type: [String, Number],
      default: '19px',
    },
  },
  computed: {
    searchClass() {
      return {
        'text-dark': this.color === 'dark',
        'text-light': this.color === 'light',
      };
    },
  },
};

</script>
